__turbopack_context__.v({
  "calendar": "BookingDetails-module__r5xYJa__calendar",
  "clearDates": "BookingDetails-module__r5xYJa__clearDates",
  "dateActions": "BookingDetails-module__r5xYJa__dateActions",
  "dateDetail": "BookingDetails-module__r5xYJa__dateDetail",
  "desktopDatesQuestionHidden": "BookingDetails-module__r5xYJa__desktopDatesQuestionHidden",
  "desktopHidden": "BookingDetails-module__r5xYJa__desktopHidden",
  "desktopLayout": "BookingDetails-module__r5xYJa__desktopLayout",
  "desktopPricingBox": "BookingDetails-module__r5xYJa__desktopPricingBox",
  "desktopPricingText": "BookingDetails-module__r5xYJa__desktopPricingText",
  "desktopPricingTitle": "BookingDetails-module__r5xYJa__desktopPricingTitle",
  "divider": "BookingDetails-module__r5xYJa__divider",
  "group": "BookingDetails-module__r5xYJa__group",
  "heading": "BookingDetails-module__r5xYJa__heading",
  "question": "BookingDetails-module__r5xYJa__question",
  "rowChevron": "BookingDetails-module__r5xYJa__rowChevron",
  "rowIcon": "BookingDetails-module__r5xYJa__rowIcon",
  "rowValue": "BookingDetails-module__r5xYJa__rowValue",
  "section": "BookingDetails-module__r5xYJa__section",
  "selectRow": "BookingDetails-module__r5xYJa__selectRow",
  "stack": "BookingDetails-module__r5xYJa__stack",
  "tripLength": "BookingDetails-module__r5xYJa__tripLength",
});
